import dev.shanty.kotwire.stimulus.Controller
import dev.shanty.kotwire.stimulus.StimulusController
import kotlinx.browser.document
import org.w3c.dom.HTMLElement
import org.w3c.dom.events.Event

@StimulusController(targets = ["menu"])
@JsExport
class DropdownController(context: dynamic) : Controller(context) {
    val menu by menuTarget<HTMLElement>()

    @JsName("toggle")
    fun toggle(event: Event) {
        event.stopPropagation()
        menu.classList.toggle("hidden")
    }

    override fun connect() {
        menu.addEventListener("click", { event ->
            event.stopPropagation()
        })
        document.addEventListener("click", { _ ->
            menu.classList.add("hidden")
        })
    }
}
